module.exports = __webpack_public_path__ + "static/auto_1-24da1e2b299f673830e9a4a779ea958e.jpg";